import React from "react"

function DividingLineIcon() {
    return (
        <svg
            className="w-full h-auto"
            viewBox="0 0 484 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
        >
            <g clipPath="url(#clip0_312_3446)">
                <path
                    d="M484 4.27908C484 3.18074 482.941 2.37649 481.047 2.37049C329.248 2.22044 170.296 -1.95684 18.6147 1.14011C13.964 1.14011 0 4.25507 0 7.41204C0 17.7712 46.5368 10.551 69.8081 10.551C107.037 7.41204 144.267 7.41204 181.502 7.41204C279.232 13.684 372.306 10.551 470.042 10.551C474.699 10.551 484.006 10.551 484.006 4.27908H484Z"
                    fill="#FDFAF2"
                />
            </g>
            <defs>
                <clipPath id="clip0_312_3446">
                    <rect width="484" height="13" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default DividingLineIcon
